module.exports = __webpack_public_path__ + "img/tele2_a276da5dd0f27a7fa41b70d5f26773cb.jpg";


//////////////////
// WEBPACK FOOTER
// ./client/img/tele2.jpg
// module id = 252
// module chunks = 0